import { useWorkspace } from '@/contexts/workspace-context';
import {
  Permission,
  createWorkspacePermissions,
  WorkspacePermissions,
} from '@optidev/shared-types';

/**
 * Hook for checking user permissions in components
 *
 * Uses shared `createWorkspacePermissions()` factory for consistency with backend.
 *
 * Usage:
 * ```tsx
 * const { can, isViewer, canEditFiles } = usePermissions();
 *
 * // Check specific permission
 * if (!can(Permission.PROJECT_CREATE)) {
 *   return null;
 * }
 *
 * // Use convenience props
 * <Button disabled={!canEditFiles}>Edit</Button>
 * ```
 */
export function usePermissions(): WorkspacePermissions {
  const { activeWorkspace } = useWorkspace();

  // Use shared factory for consistency with backend PermissionsService
  return createWorkspacePermissions({
    role: activeWorkspace?.role,
    isOwner: activeWorkspace?.isOwner,
  });
}

// Re-export Permission for convenience
export { Permission };
